// src/components/AboutSection.js (Restaurado: Las rutas de Servicios y Avalúos quedan como las definió el usuario)

import React from 'react';
import { useNavigate } from 'react-router-dom'; // 🔑 Importamos useNavigate
import './AboutSection.css'; 

import { FaUsers, FaBalanceScale, FaChartLine } from 'react-icons/fa'; 

// 🛑 ELIMINAMOS LA PROP { setActivePage }
const AboutSection = () => {
    // 🔑 Inicializamos useNavigate
    const navigate = useNavigate(); 

    const aboutCards = [
        {
            title: "Equipo de Trabajo",
            icon: FaUsers,
            description: "Giovanni Scarvaci & Asociados ha logrado conformar un equipo profesional altamente capacitado, demostrando probidad, lealtad y ética.",
            // ✅ RUTA DE EQUIPO
            route: '/quienes-somos', 
        },
        {
            title: "Asesorías Legales",
            icon: FaBalanceScale,
            description: "Asesorar sobre derechos y obligaciones. Representamos en casos mercantiles, civiles e inquilinarios, brindando asistencia jurídica integral.",
            // 🛑 RUTA ORIGINAL DEL USUARIO
            route: '/servicios',
        },
        {
            title: "Avalúos Periciales",
            icon: FaChartLine,
            description: "Peritos Avaluadores en bienes raíces, maquinaria, equipos agropecuarios y avalúos especiales. Incluye consultoría, revisión e impugnación.",
            // 🛑 RUTA ORIGINAL DEL USUARIO
            route: '/servicios', 
        },
    ];

    // Función unificada que usa useNavigate
    const handleNavigation = (route) => {
        navigate(route);
    };

    return (
        <section id="about-section" className="section about-container">
            <div className="about-header">
                <h2>Sobre Nosotros</h2>
                <p>"Tu confianza es nuestra prioridad: Nuestra firma se rige por el secreto profesional y la ética legal venezolana. Aseguramos la confidencialidad absoluta de toda la información legal y patrimonial que compartas con nosotros, garantizando que ningún tercero tendrá acceso a tu data sin tu consentimiento expreso o mandato judicial.".</p>
            </div>
            
            <div className="about-cards-grid">
                {aboutCards.map((card, index) => (
                    <div key={index} className="about-card">
                        <card.icon className="about-card-icon" /> 
                        <h3>{card.title}</h3>
                        <p>{card.description}</p>
                        <button 
                            className="ver-mas-button" 
                            // 🔑 Usamos la función de navegación con la ruta
                            onClick={() => handleNavigation(card.route)}
                        >
                            Ver más
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default AboutSection;